"use strict";
import baseStyles from "./src/spectrum-base.css.js";
import langStyles from "./src/spectrum-lang.css.js";
import bodyStyles from "./src/spectrum-body.css.js";
export default [baseStyles, langStyles, bodyStyles];
//# sourceMappingURL=body.dev.js.map
